import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';
import Input from 'components/common/Input';
import { useParams, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import IconButton from 'components/common/IconButton';
import { getItemFromStore, setItemToStore } from 'helpers/utils';
import { projectService } from 'services';
import { useQuery } from '@tanstack/react-query';
import useErrors from 'hooks/useErrors';

const BulAction = ({ selectedRowIds, allColumns, rows }) => {
 const { projectId } = useParams();
 const { setError } = useErrors();
 const [projects, setProjects] = useState([]);
 const [selectProject, setSelectProject] = useState(projectId ?? '');
 const [oldItems, setOldItems] = useState(getItemFromStore('oldItems', []));

 const [params] = useSearchParams();
 const [items, setItems] = useState(params.get('products')?.split(',') ?? []);

 const [selects, setSelects] = useState(false);
 const location = useLocation();
 const navigate = useNavigate();

 const { getProjectsNames } = projectService.useApiProjects();

 useQuery({
  queryKey: ['projectsNames'],
  queryFn: () => getProjectsNames(),
  onSuccess: data => setProjects(data),
  //onSettled: () => console.log('termino la carga'),
  onError: err => setError(err)
  //   staleTime: Infinity
 });

 const onChange = ({ target: { value } }) => {
  setSelectProject(value);
  if (projectId) {
   const regex = new RegExp(`/${projectId}[^]+|/${projectId}`, 'g');
   return navigate(location.pathname.replace(regex, value ? `/${value}` : ''), {
    replace: true,
    preserveScroll: true,
    preserveFocus: true
   });
  }
  return navigate(`${location.pathname}/${value}`, {
   replace: true,
   preserveScroll: true,
   preserveFocus: true
  });
 };

 useEffect(() => {
  setItems(params.get('products')?.split(',') ?? []);
 }, [params]);

 useEffect(() => {
  setItemToStore('oldItems', oldItems);
 }, [oldItems]);

 useEffect(() => {
  if (projectId) return setSelectProject(projectId);
 }, [projectId]);

 useEffect(() => {
  setSelects(Object.keys(selectedRowIds).length > 0);
 }, [selectedRowIds]);

 useEffect(() => {
  if (!items.length) {
   allColumns.find(e => e.id === 'selection')?.toggleHidden(false);
   rows.map(a => {
    const old = oldItems.some(e => e === a?.original?._id);
    a.toggleRowSelected(old);
    if (old) setOldItems(oldItems.filter(e => e !== a?.original?._id));
   });
  } else allColumns.find(e => e.id === 'selection')?.toggleHidden(true);
 }, [items]);

 const accion = (itms = false) => {
  itms = itms ? '' : `?products=${rows.filter(e => e?.isSelected).map(e => e?.original?._id)}`;

  if (!itms) setOldItems(items);

  if (/\?[^]+/g.test(location.pathname))
   return navigate(location.pathname.replace(/\?[^]+/g, itms), {
    replace: true,
    preserveScroll: true,
    preserveFocus: true
   });
  else
   return navigate(location.pathname + itms, {
    replace: true,
    preserveScroll: true,
    preserveFocus: true
   });
 };

 return (
  <Flex alignItems="center" wrap="wrap" className="mb-3">
   <h6 className="fs-6 m-0 text-primary">P</h6>
   <div className="flex-grow-1">
    <h4 className="m-0 text-primary">roductos</h4>
    <p className="fs--2 m-0">Seleccicione el proyecto y los productos de tu interes</p>
   </div>
   <div className="flex-1 pe-3">
    {selects || items.length ? (
     <h5 className="m-0 text-end">{projects.find(e => e._id === selectProject)?.name}</h5>
    ) : (
     <Input
      type="select"
      name="status"
      placeholder="Seleccione Proyecto"
      options={projects.map(e => ({ label: e.name, value: e._id }))}
      formControlProps={{ onChange, value: selectProject, size: 'sm' }}
     />
    )}
   </div>
   <div className="border-start border-3 ps-3 border-primary">
    {selects ? (
     <IconButton variant="falcon-primary" size="sm" icon="plus" children="Aplicar" onClick={() => accion()} />
    ) : (
     <IconButton variant="falcon-primary" size="sm" icon="check" children="Seleccionar" onClick={() => accion(true)} />
    )}
   </div>
  </Flex>
 );
};

BulAction.propTypes = {
 selectedRowIds: PropTypes.object,
 globalFilter: PropTypes.any,
 setGlobalFilter: PropTypes.any,
 groupBy: PropTypes.any,
 expanded: PropTypes.any,
 allColumns: PropTypes.any,
 getToggleHideAllColumnsProps: PropTypes.any,
 resetData: PropTypes.any,
 updateMyData: PropTypes.func,
 rows: PropTypes.any,
 value: PropTypes.any,

 onChange: PropTypes.func,
 projects: PropTypes.arrayOf(PropTypes.object),
 products: PropTypes.arrayOf(PropTypes.object),
 selectProject: PropTypes.string,
 items: PropTypes.arrayOf(PropTypes.string),
 oldItems: PropTypes.arrayOf(PropTypes.string),
 setOldItems: PropTypes.func
};

export default BulAction;
